import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Pagination = ({ currentPage, onPageChange, pageCount }) => {
  if (!pageCount) return null;

  const back = () => currentPage > 1 && onPageChange(currentPage - 1);
  const next = () => currentPage < pageCount && onPageChange(currentPage + 1);

  const drawPageCountButton = (
    currentPage === pageCount
    || currentPage + 1 === pageCount
    || currentPage + 2 === pageCount
  );

  return (
      <div className="pagination-wrap">
      {pageCount > 1 && (
        <div className="pagination-inner">
          <span aria-hidden="true" className={`page ${currentPage <= 1 ? 'disabled' : ''}`} onClick={back}>
            <i className="icon-slim-arrow-left" />
          </span>

          {(currentPage === 1 || currentPage - 1 === 1 || currentPage - 2 === 1)
            ? null
            : <span aria-hidden="true" className="page" onClick={() => onPageChange(1)}>{1}</span>}

          {currentPage - 3 > 1
            ? <span aria-hidden="true" className="page">...</span>
            : null}

          {currentPage - 2 >= 1
            ? <span aria-hidden="true" className="page" onClick={() => onPageChange(currentPage - 2)}>{currentPage - 2}</span>
            : null}

          {currentPage - 1 >= 1
            ? <span aria-hidden="true" className="page" onClick={() => onPageChange(currentPage - 1)}>{currentPage - 1}</span>
            : null}

          <span aria-hidden="true" className="page selected" onClick={() => onPageChange(currentPage)}>{currentPage}</span>

          {currentPage + 1 <= pageCount
            ? <span aria-hidden="true" className="page" onClick={() => onPageChange(currentPage + 1)}>{currentPage + 1}</span>
            : null}

          {currentPage + 2 <= pageCount
            ? <span aria-hidden="true" className="page" onClick={() => onPageChange(currentPage + 2)}>{currentPage + 2}</span>
            : null}

          {currentPage + 3 < pageCount ? <span aria-hidden="true" className="page">...</span> : null}

          {drawPageCountButton
            ? null
            : <span aria-hidden="true" className="page" onClick={() => onPageChange(pageCount)}>{pageCount}</span>}

          <span aria-hidden="true" className={`page ${currentPage >= pageCount ? 'disabled' : ''}`} onClick={next}>
            <i className="icon-slim-arrow-right" />
          </span>
        </div>
      )}
      </div>

  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageCount: PropTypes.number,
};

export default Pagination;
